import request from '@/utils/request'
import {queryParams} from '@/utils/index'

export function getUserMsg(data) {
  let paramsStr = queryParams(data);
  return request({
    url: `/member/getMyUserById?${paramsStr}`,
    method: 'post',
    // data
  })
}

export function getMycapital(data) {
  let paramsStr = queryParams(data);
  return request({
    url: `/cut/payment/mycapital?${paramsStr}`,
    method: 'post'
  })
}

export function payMement(data) {
  let paramsStr = queryParams(data);
  return request({
    url: `/cut/payment/result?${paramsStr}`,
    method: 'post'
  })
}

export function income(data) {
  let paramsStr = queryParams(data);
  return request({
    url: `/cut/payment/today/income?${paramsStr}`,
    method: 'post'
  })
}

export function consumeDetail(data) {
  let paramsStr = queryParams(data);
  return request({
    url: `/cut/payment/today/consume/detail?${paramsStr}`,
    method: 'post'
  })
}

/* export function readAd(data) {
  return request({
    url: '/ad/read',
    method: 'get',
    data
  })
} */


// WEBPACK FOOTER //
// ./src/api/index.js